import React, { Fragment, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import './Beneficiaries.scss';
import LegalCopy from 'components/shared/LegalCopy/LegalCopy';
import Content from 'services/Content';
import BeaconAccordion from 'components/shared/BeaconAccordion/BeaconAccordion';
import { faqItems } from './Utils';
import BeneficiariesDataCardGroup from './BeneficiariesDataCardGroup';
import { getAgreementBeneficiaries } from 'services/Rest';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import {
    formatManagedBeneficiaries,
    getBeneficiaryCardsData,
    isNotQualifiedForBeneficiaries,
    getAgreementsGroupedByRegistrationKey
} from 'state/beneficiaries/BeneficiarySelectors';
import {
    hasIndividualOrJointTenant,
    hasROTHOrTraditionalInheritedIRABene,
    hasWorkplaceRetirementAccounts
} from 'state/view/ViewSelectors';
import Store from 'state/Store';
import { updateManageBeneficiaries } from 'state/beneficiaries/BeneficiaryActions';
import { StepProvider } from './StepProvider';
import BeneficiariesUserFlow from './BeneficiariesUserFlow';
import BeneficiaryContext from './BeneficiaryContext';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import BeneficiariesViewInvestmentsModal from './BeneficiariesViewInvestmentModal';
import { cloneDeep } from 'lodash';
import { footerLinks, preferencesLink, preferencesLinks } from 'services/Externals';
import { AAMBeaconButton } from 'components/shared/Beacon';
import { getHasWorkPlaceRetirementAccounts } from 'state/account/AccountSelectors';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

export const BeneficiariesFooter = ({ hasIndividualOrJointTenantFooter, hasROTHOrTraditionalInheritedIRABeneFooter, hasWorkplaceRetirementAccountsFooter }) => {
    const shouldShowImportantInformation = hasIndividualOrJointTenantFooter || hasROTHOrTraditionalInheritedIRABeneFooter || hasWorkplaceRetirementAccountsFooter;

    return (
      <div className="beneFooter">
          {shouldShowImportantInformation && (
            <div>
                <div className="important-information-v2">Important Information</div>
                {hasIndividualOrJointTenantFooter && (
                  <LegalCopy content={Content.beneficiaryImportantInfo.individualOrJoint} />
                )}
                {(hasROTHOrTraditionalInheritedIRABeneFooter) && (
                  <LegalCopy content={Content.beneficiaryImportantInfo.inheritedRothOrTraditionalIRAText} />
                )}
                {hasWorkplaceRetirementAccountsFooter && (
                  <LegalCopy content={Content.beneficiaryImportantInfo.NewbenetracOrWorkplaceRPS} />
                )}
            </div>
          )}
      </div>
    );
};

const Beneficiaries = ({ beneficiaryCardsData, isNotQualified, requestStatus, beneficiaries, agreementsGroupedByRegistrationKey, isCustomerWebView, hasIndividualOrJointTenantFooter, hasROTHOrTraditionalInheritedIRABeneFooter, hasWorkplaceRetirementAccountsFooter, hasWorkplaceRetirementAccount }) => {
    const {
        primaryTotalAllocationFormatted,
        secondaryTotalAllocationFormatted
    } = beneficiaries || {};
    const formRef = useRef(null);
    const [addBeneficiariesModal, setAddBeneficiaries] = useState(false);
    const [manageBeneficiaries, setManageBeneficiaries] = useState(false);
    const [addTODBeneficiariesModal, setAddTODBeneficiaries] = useState(false);
    const [viewInvestments, setViewInvestments] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [agreementsForBeneUpdate, setAgreementsForBeneUpdate] = useState([]);
    const [registrationKeyForMismatchUpdate, setRegistrationKeyForMismatchUpdate] = useState(null);
    const [selectedBeneficiaryId, setSelectedBeneficiaryId] = useState(null);
    const [updatedBeneficiary, setUpdatedBeneficiary] = useState({});
    const [deletedBeneficiary, setDeletedBeneficiary] = useState({});
    const [recentBeneficiary, setRecentBeneficiary] = useState({});
    const [isEdited, setIsEdited] = useState(false);
    const [isAdded, setIsAdded] = useState(false);
    const [includeDistributionValidation, setIncludeDistributionValidation] = useState(false);
    const [isMismatch, setIsMismatch] = useState(false);
    const [invalidField, setInvalidField] = useState([]);
    const [isinvalidDelete, setIsinvalidDelete] = useState(false);
    const [isEsa, setIsEsa] = useState(false);
    const [isIndividual, setIsIndividual] = useState(false);
    const [isJoint, setIsJoint] = useState(false);
    const [enableErrorMessage, setEnableErrorMessage] = useState(true);
    const [beneficiaryDataIsComplete, setBeneficiaryDataIsComplete] = useState(true);

    useEffect(() => {
        getAgreementBeneficiaries();
    }, []);
    useEffect(() => {
        if (requestStatus.updateBeneficiaries &&
          requestStatus.updateBeneficiaries === REQUEST_STATES.received) {
            getAgreementBeneficiaries();
        }
    }, [requestStatus.updateBeneficiaries]);
    const handleAddBeneficiary = (beneficiaries, mismatch, isEducationSavingsAccount) => {
        setIsEsa(isEducationSavingsAccount);
       //Delete all beneficiaries for mastach senario
        const modifiedBeneficiaries = cloneDeep(beneficiaries);
        if (mismatch) {
            modifiedBeneficiaries.primary = [];
            modifiedBeneficiaries.secondary = [];
        }
        Store.dispatch(updateManageBeneficiaries(modifiedBeneficiaries));
        setAddBeneficiaries(true);
        //to identifiy if it is add or Mismatch flow
        setIsMismatch(mismatch);
    };
    const handleTODAccounts = (todBeneficiaries, isIndividualTOD, isJointTOD) => {
        Store.dispatch(updateManageBeneficiaries(todBeneficiaries));
        setIsIndividual(isIndividualTOD);
        setIsJoint(isJointTOD);
        setAddTODBeneficiaries(true);
    }
    const handleManageBeneficiary = (beneficiaries, isEducationSavingsAccount) => {
        setIsEsa(isEducationSavingsAccount);
        Store.dispatch(updateManageBeneficiaries(beneficiaries));
        setManageBeneficiaries(true);
    };

    const handleViewInvestments = () => {
        setViewInvestments(true);
    };


    return (
      <Fragment>
          <div className="beneficiaries-header-v2">Beneficiaries</div>
          <div className="beneficiaries-container-v2">
              {isNotQualified ? <div className="b-grid-item--8-col b-sm:12-col b-xl:8-col not-qualified-container-v2">
                  <div className="not-qualified-beneficiaries-v2">
                      {/* eslint-disable-next-line react/no-unescaped-entities */}
                      <div className="b-typography-serif--headline--500 b-font-weight-bold">You don't have T. Rowe Price personal investing accounts eligible for beneficiaries.</div>
                      <div className="b-typography-sans-serif--headline--100 b-font-weight-light">
                          {/* eslint-disable-next-line react/no-unescaped-entities */}
                          <a href={footerLinks.contactUsUrl} target="_blank" rel="noopener noreferrer">Contact us</a> if you believe you've received this message in error.
                      </div>
                      {hasWorkplaceRetirementAccount && (
                        <Fragment>
                            <div className="b-typography-sans-serif--headline--100 b-font-weight-light update-workplace-retirement">
                                <a href={preferencesLinks.BeneficiaryWorkplaceRetirementProfileUrl} target="_blank" rel="noopener noreferrer">Update</a> your Workplace Retirement beneficiaries.
                            </div>
                        </Fragment>
                      )}
                      <AAMBeaconButton
                        id={'benes-zero-state-back-to-profile-button'}
                        linkHref={preferencesLink}
                        variant={'tertiary'}
                        scale={'jumbo'}
                      >
                        Go to Profile & Settings
                      </AAMBeaconButton>
                  </div>
              </div> : (
                <Fragment>
                    {(addBeneficiariesModal || manageBeneficiaries || addTODBeneficiariesModal) && (
                      <BeneficiaryContext.Provider value={{
                          selectedGroup,
                          selectedBeneficiaryId,
                          setSelectedBeneficiaryId,
                          setAddBeneficiaries,
                          setManageBeneficiaries,
                          setAddTODBeneficiaries,
                          beneficiaries,
                          formRef,
                          addBeneficiariesModal,
                          manageBeneficiaries,
                          addTODBeneficiariesModal,
                          updatedBeneficiary,
                          deletedBeneficiary,
                          setDeletedBeneficiary,
                          agreementsForBeneUpdate,
                          agreementsGroupedByRegistrationKey,
                          registrationKeyForMismatchUpdate,
                          isEdited,
                          setIsEdited,
                          isAdded,
                          setIsAdded,
                          setUpdatedBeneficiary,
                          includeDistributionValidation,
                          setIncludeDistributionValidation,
                          primaryTotalAllocationFormatted,
                          secondaryTotalAllocationFormatted,
                          isMismatch,
                          setIsMismatch,
                          invalidField,
                          setInvalidField,
                          isinvalidDelete,
                          setIsinvalidDelete,
                          isCustomerWebView,
                          isEsa,
                          isIndividual,
                          isJoint,
                          setRecentBeneficiary,
                          recentBeneficiary,
                          enableErrorMessage,
                          setEnableErrorMessage,
                          beneficiaryDataIsComplete,
                          setBeneficiaryDataIsComplete
                      }}>
                          <StepProvider>
                              <BeneficiariesUserFlow />
                          </StepProvider>
                      </BeneficiaryContext.Provider>
                    )}
                    {viewInvestments && (
                      <BeneficiaryContext.Provider value={{
                          setViewInvestments,
                          agreementsForBeneUpdate
                      }}>
                          <BeneficiariesViewInvestmentsModal />
                      </BeneficiaryContext.Provider>
                    )}
                    <div className="b-grid">
                        <div className="b-grid-item--8-col b-sm:12-col b-xl:8-col beneficiaries-datacard-group-column">
                            <BeneficiariesDataCardGroup
                              setSelectedGroup={setSelectedGroup}
                              handleHeaderCTA={handleViewInvestments}
                              handleAddBeneficiary={handleAddBeneficiary}
                              handleManageBeneficiary={handleManageBeneficiary}
                              setAgreementsForBeneUpdate={setAgreementsForBeneUpdate}
                              setRegistrationKeyForMismatchUpdate={setRegistrationKeyForMismatchUpdate}
                              beneficiaryCardsData={beneficiaryCardsData}
                              selectedGroup={selectedGroup}
                              handleTODAccounts={handleTODAccounts}
                            />
                        </div>
                        <div className="b-grid-item--4-col b-sm:12-col b-xl:4-col accordian">
                            <BeaconAccordion
                              items={faqItems}
                              renderItem={(item) => ({
                                  title: item.question,
                                  panel: item.answer
                              })}
                            />
                        </div>
                    </div>
                    <div className="beneficiaries-legal-copy-text-v2">
                        <BeneficiariesFooter
                          hasIndividualOrJointTenantFooter={hasIndividualOrJointTenantFooter}
                          hasROTHOrTraditionalInheritedIRABeneFooter={hasROTHOrTraditionalInheritedIRABeneFooter}
                          hasWorkplaceRetirementAccountsFooter={hasWorkplaceRetirementAccountsFooter}
                        />
                        <LegalCopy content={Content.beneficiaryDisclosure} />
                    </div>
                </Fragment>
              )}
          </div>
      </Fragment>
    );
};

const mapStateToProps = (state) => ({
    beneficiaryCardsData: getBeneficiaryCardsData(state),
    isNotQualified: isNotQualifiedForBeneficiaries(state),
    requestStatus: getRequestStatus(state),
    beneficiaries: formatManagedBeneficiaries(state),
    agreementsGroupedByRegistrationKey: getAgreementsGroupedByRegistrationKey(state),
    hasIndividualOrJointTenantFooter: hasIndividualOrJointTenant(state),
    hasROTHOrTraditionalInheritedIRABeneFooter: hasROTHOrTraditionalInheritedIRABene(state),
    hasWorkplaceRetirementAccountsFooter: hasWorkplaceRetirementAccounts(state),
    isCustomerWebView: getCustomerWebView(state),
    hasWorkplaceRetirementAccount: getHasWorkPlaceRetirementAccounts(state)
});

export default connect(mapStateToProps)(Beneficiaries);